import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoCotaDistribVeiculo({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'visuacotadistribveiculo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoCotaDistribVeiculo({ payload }) {
  try {
    const { orga_codigo, unid_codigo, veic_placa, params } = payload;

    yield call(api.delete, `visuacotadistribveiculo/${orga_codigo}/${unid_codigo}/${veic_placa}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaocotadistribveiculo, params } = payload;

    yield call(
      api.post,
      'visuacotadistribveiculo',
      operacaocotadistribveiculo
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/visuacotadistribveiculo');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { orga_codigo, unid_codigo, veic_placa } = payload;

    const { data } = yield call(
      api.get,
      `visuacotadistribveiculo/${orga_codigo}/${unid_codigo}/${veic_placa}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaocotadistribveiculo, params } = payload;

    yield call(
      api.put,
      'visuacotadistribveiculo',
      operacaocotadistribveiculo
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/visuacotadistribveiculo');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'visuacotadistribveiculo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaocotadistribveiculo/VISUACOTADISTRIBVEICULO_IN_REQUEST',
    requestOperacaoCotaDistribVeiculo
  ),
  takeLatest(
    '@operacaocotadistribveiculo/DELETE_VISUACOTADISTRIBVEICULO',
    deleteOperacaoCotaDistribVeiculo
  ),
  takeLatest(
    '@operacaocotadistribveiculo/SUCCESS_REMOVE',
    requestOperacaoCotaDistribVeiculo
  ),
  takeLatest(
    '@operacaocotadistribveiculo/STORE_VISUACOTADISTRIBVEICULO',
    store
  ),
  takeLatest(
    '@operacaocotadistribveiculo/FIND_VISUACOTADISTRIBVEICULO',
    find
  ),
  takeLatest(
    '@operacaocotadistribveiculo/UPDATE_VISUACOTADISTRIBVEICULO',
    update
  ),
  takeLatest(
    '@operacaocotadistribveiculo/RECORD_FILTERING',
    applyedFilters
  ),
]);
